import React from 'react';
import FixedPlugin from '../FixedPlugin/FixedPlugin';
import './Header.css';

const Header = () => {
  const metrics = [
    { 
      title: 'Today Orders', 
      value: '32,562', 
      percentage: '10%', 
      comparison: '126 ↗ vs. previous month' 
    },
    { 
      title: 'Today Visitor', 
      value: '26,429', 
      percentage: '23%', 
      comparison: '568 ↗ vs. previous month' 
    },
    { 
      title: 'Total Expense', 
      value: '64,249', 
      percentage: '32%', 
      comparison: '232 ↗ vs. previous month' 
    },
    { 
      title: 'New Users', 
      value: '52,653', 
      percentage: '18%', 
      comparison: '235 ↗ vs. previous month' 
    }
  ];

  return (
    <header className="header-dashboard">
      <div className="header-top-section">
        <div className="header-title-container">
          <h1 className="header-title">DASHBOARD</h1>
        </div>
        <div className="header-plugin-container">
          <FixedPlugin />
        </div>
      </div>
      
      <div className="header-content-wrapper">
        <div className="header-metrics-grid">
          {metrics.map((metric, index) => (
            <div key={index} className="header-metric-card">
              <h3 className="header-metric-title">{metric.title}</h3>
              <div className="header-metric-main">
                <span className="header-metric-value">{metric.value}</span>
                <span className="header-metric-percentage">{metric.percentage}</span>
              </div>
              <p className="header-metric-comparison">{metric.comparison}</p>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;